var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58398 8.16699H20.4173",
    stroke: "#E55C73",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58398 19.833H20.4173",
    stroke: "#E55C73",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 23.3333V21C7 19.1435 7.7375 17.363 9.05025 16.0503C10.363 14.7375 12.1435 14 14 14C15.8565 14 17.637 14.7375 18.9497 16.0503C20.2625 17.363 21 19.1435 21 21V23.3333C21 23.6428 20.8771 23.9395 20.6583 24.1583C20.4395 24.3771 20.1428 24.5 19.8333 24.5H8.16667C7.85725 24.5 7.5605 24.3771 7.34171 24.1583C7.12292 23.9395 7 23.6428 7 23.3333Z",
    stroke: "#E55C73",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.66667V7C7 8.85652 7.7375 10.637 9.05025 11.9497C10.363 13.2625 12.1435 14 14 14C15.8565 14 17.637 13.2625 18.9497 11.9497C20.2625 10.637 21 8.85652 21 7V4.66667C21 4.35725 20.8771 4.0605 20.6583 3.84171C20.4395 3.62292 20.1428 3.5 19.8333 3.5H8.16667C7.85725 3.5 7.5605 3.62292 7.34171 3.84171C7.12292 4.0605 7 4.35725 7 4.66667V4.66667Z",
    stroke: "#E55C73",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.cca9190fd822c0802f348c39744a9254.svg";
export { ForwardRef as ReactComponent };